import { useTranslation as useTranslationContext } from '../contexts/TranslationProvider';

const useTranslation = () => {
  const translationContext = useTranslationContext();
  return translationContext;
};

export default useTranslation;